module.exports = __webpack_public_path__ + "static/media/ai.307294bc.svg";